import { render, staticRenderFns } from "./BouncedEmailAlert.vue?vue&type=template&id=2c8d181a"
import script from "./BouncedEmailAlert.vue?vue&type=script&lang=js"
export * from "./BouncedEmailAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports